import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=3b515bc1&scoped=true"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"
import style0 from "./demo.vue?vue&type=style&index=0&id=3b515bc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b515bc1",
  null
  
)

export default component.exports